import { render, staticRenderFns } from "./UserSettings.vue?vue&type=template&id=345f3852&scoped=true"
import script from "./UserSettings.vue?vue&type=script&lang=js"
export * from "./UserSettings.vue?vue&type=script&lang=js"
import style0 from "./UserSettings.vue?vue&type=style&index=0&id=345f3852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345f3852",
  null
  
)

export default component.exports